import _asyncToGenerator from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/help/help/node_modules/@babel/runtime/regenerator/index.js";
var enc = new TextEncoder();

function sign(_x, _x2) {
  return _sign.apply(this, arguments);
}

function _sign() {
  _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(secret, data) {
    var signature;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = crypto.subtle;
            _context.next = 3;
            return importKey(secret);

          case 3:
            _context.t1 = _context.sent;
            _context.t2 = enc.encode(data);
            _context.next = 7;
            return _context.t0.sign.call(_context.t0, "HMAC", _context.t1, _context.t2);

          case 7:
            signature = _context.sent;
            return _context.abrupt("return", UInt8ArrayToHex(signature));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sign.apply(this, arguments);
}

function verify(_x3, _x4, _x5) {
  return _verify.apply(this, arguments);
}

function _verify() {
  _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(secret, data, signature) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = crypto.subtle;
            _context2.next = 3;
            return importKey(secret);

          case 3:
            _context2.t1 = _context2.sent;
            _context2.t2 = hexToUInt8Array(signature);
            _context2.t3 = enc.encode(data);
            _context2.next = 8;
            return _context2.t0.verify.call(_context2.t0, "HMAC", _context2.t1, _context2.t2, _context2.t3);

          case 8:
            return _context2.abrupt("return", _context2.sent);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _verify.apply(this, arguments);
}

function hexToUInt8Array(string) {
  // convert string to pairs of 2 characters
  var pairs = string.match(/[\dA-F]{2}/gi); // convert the octets to integers

  var integers = pairs.map(function (s) {
    return parseInt(s, 16);
  });
  return new Uint8Array(integers);
}

function UInt8ArrayToHex(signature) {
  return Array.prototype.map.call(new Uint8Array(signature), function (x) {
    return x.toString(16).padStart(2, "0");
  }).join("");
}

function importKey(_x6) {
  return _importKey.apply(this, arguments);
}

function _importKey() {
  _importKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(secret) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", crypto.subtle.importKey("raw", // raw format of the key - should be Uint8Array
            enc.encode(secret), {
              // algorithm details
              name: "HMAC",
              hash: {
                name: "SHA-256"
              }
            }, false, // export = false
            ["sign", "verify"] // what this key can do
            ));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _importKey.apply(this, arguments);
}

export { sign, verify };